// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"1316e436","404":"2ef33ea2","498":"65909b54","787":"bbc0d653"}[chunkId] + ".chunk.js";
};